import { apiFetch } from "./client";

export interface UsageRange {
  from?: string;
  to?: string;
}

export interface UsageSummary {
  range: { from: string; to: string };
  activeUsers: number;
  totalSessions: number;
  totalMessages: number;
  userMessages: number;
  assistantMessages: number;
  inputTokens: number;
  outputTokens: number;
  cacheCreateTokens: number;
  cacheReadTokens: number;
  totalCostCents: number;
}

export interface UsageUserRow {
  tenantUserId: string;
  externalId: string | null;
  email: string;
  displayName: string | null;
  role: string;
  authProvider: string;
  lastLoginAt: string | null;
  sessions: number;
  messages: number;
  inputTokens: number;
  outputTokens: number;
  cacheCreateTokens: number;
  cacheReadTokens: number;
}

export interface UsageAgentRow {
  agentId: string;
  agentName: string;
  sessions: number;
  messages: number;
  inputTokens: number;
  outputTokens: number;
  cacheCreateTokens: number;
  cacheReadTokens: number;
  costCents: number;
  modelBreakdown: Record<string, number>;
}

export interface UsageTimeseriesPoint {
  day: string;
  messages: number;
  inputTokens: number;
  outputTokens: number;
}

export interface UsageSigninRow {
  authSessionId: string;
  email: string;
  displayName: string | null;
  authProvider: string;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
  expiresAt: string;
}

function qs(companyId: string, range: UsageRange, extra: Record<string, string | number | undefined> = {}): string {
  const params = new URLSearchParams({ companyId });
  if (range.from) params.set("from", range.from);
  if (range.to) params.set("to", range.to);
  for (const [k, v] of Object.entries(extra)) {
    if (v !== undefined) params.set(k, String(v));
  }
  return params.toString();
}

export const usageApi = {
  summary: (companyId: string, range: UsageRange = {}) =>
    apiFetch<UsageSummary>(`/usage/summary?${qs(companyId, range)}`),
  users: (companyId: string, range: UsageRange = {}) =>
    apiFetch<UsageUserRow[]>(`/usage/users?${qs(companyId, range)}`),
  agents: (companyId: string, range: UsageRange = {}) =>
    apiFetch<UsageAgentRow[]>(`/usage/agents?${qs(companyId, range)}`),
  timeseries: (companyId: string, range: UsageRange = {}) =>
    apiFetch<UsageTimeseriesPoint[]>(`/usage/timeseries?${qs(companyId, range)}`),
  signins: (companyId: string, range: UsageRange = {}, limit = 100) =>
    apiFetch<UsageSigninRow[]>(`/usage/signins?${qs(companyId, range, { limit })}`),
};
